/* @flow */

import React from 'react';
import PropTypes from 'prop-types';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { translate } from 'store/modules/base/i18n';
import { connect } from 'store/modules/base/redux';

/**
 * Notice react component.
 *
 * @class Notice
 */
class Notice extends React.PureComponent {
  /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   * @returns {ReactElement}
   */
  render() {
    if (!this.props._message) {
      return null;
    }

    return (
      <div className="notice">
        <span className="notice__message">{this.props._message}</span>
      </div>
    );
  }
}

Notice.propTypes = {
  _message: PropTypes.string
};

/**
 * Maps (parts of) the Redux state to the associated
 * {@code Notice}'s props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _message: string,
 * }}
 */
function _mapStateToProps(state) {
  const { noticeMessage } = state['features/base/config'];

  return {
    _message: noticeMessage
  };
}
export default React.memo(
  translate(connect(_mapStateToProps)(withBoundary(Notice)))
);
